import { render } from "./EditTrimInfoModal.vue?vue&type=template&id=b6ca95ac"
import script from "./EditTrimInfoModal.vue?vue&type=script&lang=js"
export * from "./EditTrimInfoModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__